module.exports = __webpack_public_path__ + "img/deyunce.3a978fd6.jpg";